import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';
import Heading from 'shopper/components/Heading';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import LINKS from 'constants/links';

const BULLET_POINTS = [
  'Receba notificações em tempo real das melhores ofertas.',
  'Crie alertas de preço personalizados e não perca nenhuma oferta.',
  'Acesse cupons e ofertas exclusivas para quem usa o app.',
];

const Card = ({ gaEventCategory }) => (
  <div className="absolute left-8 top-5 flex w-[312px] flex-col items-center gap-4 rounded-3 bg-neutral-high-100 p-4 md:-top-12 md:w-1/2 md:p-6">
    <div className="flex flex-col gap-2">
      <Heading
        as="h3"
        className="mb-3 text-base dark:text-neutral-low-500"
        size="size4"
      >
        {placeholder('titles.bfDownloadApp')}
      </Heading>
      {BULLET_POINTS.map((point) => (
        <Text
          key={point}
          className="flex items-center text-sm dark:text-neutral-low-500"
        >
          <Icon
            className="mr-2 text-neutral-low-500 dark:text-neutral-low-500"
            name="promobit-filled"
          />
          {point}
        </Text>
      ))}
    </div>
    <Button
      as="a"
      className="flex bg-primary-500 md:hidden"
      href={LINKS.APP_DOWNLOAD_LANDINGS_MOBILE}
      rel="noopener noreferrer"
      size="size2"
      target="_blank"
      onClick={() => {
        sendEvent({
          action: 'modal_download_app',
          category: gaEventCategory,
        });
      }}
    >
      {placeholder('actions.clickToDownload')}
    </Button>
  </div>
);

Card.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default Card;
